import { ChangeDetectorRef, ComponentRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SgAuxRouter } from './aux-router.service';
import { SgAuxRouteBridgeOutlet } from './models';

export class SgAuxRouteRef<T extends SgAuxRouteBridgeOutlet = SgAuxRouteBridgeOutlet> {
  get cdr(): ChangeDetectorRef {
    return this._cdr;
  }

  private cmpRef: ComponentRef<any>;

  private constructor(
    private _cdr: ChangeDetectorRef,
    public readonly route: ActivatedRoute,
    public readonly auxRouter: SgAuxRouter,
    public readonly outlet: T
  ) {}

  destroy(): void {
    if (!this.cmpRef) {
      // TODO: cache calls made before the ref is ready and run them later.
      // even if it doesn't make sense.
    } else {
      this.auxRouter.closeRouteFromInstance(this.cmpRef.instance);
    }
  }

  static create<T extends SgAuxRouteBridgeOutlet = SgAuxRouteBridgeOutlet>(
    cdr: ChangeDetectorRef,
    route: ActivatedRoute,
    auxRouter: SgAuxRouter,
    outlet: T
  ): { auxRef: SgAuxRouteRef; update(cmpRef: ComponentRef<any>): void } {
    const auxRef = new SgAuxRouteRef<T>(cdr, route, auxRouter, outlet);
    const update = (cmpRef: ComponentRef<any>) => {
      auxRef.cmpRef = cmpRef;
      auxRef._cdr = cmpRef.changeDetectorRef;
    };

    return { auxRef, update };
  }
}
